import { makeStyles } from '@material-ui/core/styles';
import { Container, styled, Typography } from '@material-ui/core';

export const Cards = styled(Container)(({ theme: { breakpoints } }) => ({
  paddingTop: '5%',
  [breakpoints.up('lg')]: {
    paddingRight: '10%',
    paddingLeft: '10%',
    paddingBottom: '10%',
  },
  [breakpoints.down('md')]: {
    paddingRight: '0%',
    paddingLeft: '2%',
    paddingBottom: '5%',
  },
}));

export const Title = styled(Typography)(({ theme: { breakpoints, spacing } }) => ({
  display: 'flex',
  fontWeight: 'bold',
  paddingBottom: spacing(4),
  fontFamily: 'Open Sans',
  [breakpoints.down('sm')]: {
    fontSize: spacing(3.2),
    alignContent: 'center',
    justifyContent: 'center',
  },
  [breakpoints.up('lg')]: {
    fontSize: spacing(3.75),
  },
}));

export const Topic = styled(Typography)(({ theme: { breakpoints, spacing } }) => ({
  fontWeight: 'bold',
  fontFamily: 'Open Sans',
  [breakpoints.down('sm')]: {
    fontSize: spacing(1.75),
  },
  [breakpoints.up('lg')]: {
    fontSize: spacing(2),
  },
}));

export const SubTopic = styled(Typography)(({ theme: { breakpoints, spacing, palette } }) => ({
  fontFamily: 'Open Sans',
  color: palette.black.main,
  [breakpoints.down('sm')]: {
    fontSize: spacing(1.5),
  },
  [breakpoints.up('lg')]: {
    fontSize: spacing(2),
  },
}));
export const SubTopic1 = styled(Typography)(({ theme: { breakpoints, spacing, palette } }) => ({
  fontFamily: 'Open Sans',
  fontWeight: 'bold',
  color: palette.gray.dark,
  [breakpoints.down('sm')]: {
    fontSize: spacing(3),
  },
  [breakpoints.up('lg')]: {
    fontSize: spacing(2.5),
  },
}));

export const SubTopicFail = styled(Typography)(({ theme: { breakpoints, spacing, palette } }) => ({
  fontFamily: 'Open Sans',
  color: palette.red.light,
  fontWeight: 'bold',
  [breakpoints.down('sm')]: {
    fontSize: spacing(1.5),
  },
  [breakpoints.up('lg')]: {
    fontSize: spacing(2),
  },
}));

export const Uploads = styled(Typography)(({ theme: { breakpoints, spacing, palette } }) => ({
  color: palette.black.main,
  fontWeight: 'bold',
  fontFamily: 'Open Sans',
  fontStyle: 'unset',
  cursor: 'pointer',
  [breakpoints.down('sm')]: {
    fontSize: spacing(1.5),
  },
  [breakpoints.up('lg')]: {
    fontSize: spacing(2),
  },
}));
export const UploadApprove = styled(Typography)(({ theme: { breakpoints, spacing, palette } }) => ({
  color: palette.green.main,
  cursor: 'pointer',
  fontWeight: 'bold',
  fontFamily: 'Open Sans',
  [breakpoints.down('sm')]: {
    fontSize: spacing(1.5),
  },
  [breakpoints.up('lg')]: {
    fontSize: spacing(2),
  },
}));
export const UploadFail = styled(Typography)(({ theme: { breakpoints, spacing, palette } }) => ({
  color: palette.red.light,
  fontWeight: 'bold',
  fontFamily: 'Open Sans',
  [breakpoints.down('sm')]: {
    fontSize: spacing(1.5),
  },
  [breakpoints.up('lg')]: {
    fontSize: spacing(2),
  },
}));

export const ViewVideo = styled(Typography)(({ theme: { breakpoints, spacing, palette } }) => ({
  color: palette.green.main,
  fontWeight: 'bold',
  fontFamily: 'Open Sans',
  fontStyle: 'unset',
  cursor: 'pointer',
  [breakpoints.down('sm')]: {
    fontSize: spacing(1.5),
  },
  [breakpoints.up('lg')]: {
    fontSize: spacing(1.8),
  },
}));

export const Image = styled('div')(({ theme: { breakpoints, spacing } }) => ({
  borderRadius: spacing(0.5),
  [breakpoints.down('sm')]: {
    width: spacing(9),
    height: spacing(6),
  },
  [breakpoints.up('md')]: {
    width: spacing(1),
    height: spacing(5),
  },
}));

export const UpcomingEventStyle = makeStyles(({ breakpoints, spacing, palette }) => ({
  image: {
    borderRadius: spacing(0.5),
    [breakpoints.down('sm')]: {
      width: '70%',
      height: spacing(15),
    },
    [breakpoints.up('md')]: {
      width: spacing(10.5),
      height: spacing(7.5),
    },
    display: 'flex',
    fill: 'cover',
  },
  imageDiv: {
    backgroundColor: palette.black.dark,
    borderRadius: spacing(0.5),
    [breakpoints.down('sm')]: {
      width: '70%',
      height: spacing(15),
    },
    [breakpoints.up('md')]: {
      width: spacing(10.5),
      height: spacing(7.5),
    },
    display: 'flex',
  },
  uploadIcon: {
    margin: 'auto',
    width: spacing(2.5),
    height: spacing(2.25),
  },
  failedIcon: {
    margin: 'auto',
    width: spacing(2.5),
    height: spacing(2.25),
    filter: 'invert(80%) sepia(90%) saturate(5607%) hue-rotate(338deg) brightness(88%) contrast(97%)',
  },

  upload: {
    backgroundColor: palette.black.dark,
    borderRadius: spacing(0.5),
    [breakpoints.down('sm')]: {
      width: '70%',
      height: spacing(15),
    },
    [breakpoints.up('md')]: {
      marginTop: '2%',
      width: spacing(10.5),
      height: spacing(7.5),
    },
    display: 'flex',
  },

  root: {
    paddingRight: '0%',
    paddingLeft: '0%',
    paddingTop: '5%',
    paddingBottom: '5%',
    textAlign: 'center',
    width: '100%',
  },
  grid: {
    display: 'flex',
    alignContent: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: '1%',
    backgroundColor: palette.red.dark,
    [breakpoints.down('md')]: {
      width: '100%',
    },
    [breakpoints.up('lg')]: {
      width: '100%',
    },
  },
  uploadContent: {
    fontFamily: 'Open Sans',
    fontSize: spacing(3),
    paddingBottom: '5%',
    color: palette.black.main,
  },
  ErrorLogo: {
    height: '30%',
    width: '30%',
    color: palette.red.main,
    paddingBottom: '5%',
    paddingTop: '10%',
  },
  uploads: {
    paddingRight: '30%',
    paddingLeft: '30%',
    backgroundColor: palette.red.dark,
  },
  availableCard: {
    marginBottom: '3%',
    marginLeft: '1%',
    marginRight: '1%',
  },
  available: {
    [breakpoints.up('md')]: {
      flexDirection: 'row',
      display: 'flex',
      marginTop: '2%',
      paddingLeft: '3%',
    },
    [breakpoints.down('sm')]: {
      flexDirection: 'column',
      display: 'flex',
      padding: '2%',
    },
  },
  availableImage: {
    marginRight: '3%',
    [breakpoints.up('md')]: {
      height: spacing(7),
      width: spacing(12.5),
    },
    [breakpoints.down('sm')]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
    },
  },
  content: {
    flexDirection: 'column',
    width: '100%',
  },
  topic: {
    [breakpoints.up('md')]: {
      minHeight: spacing(4.4),
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      width: '80%',
    },
    [breakpoints.down('sm')]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  subTopic: {
    [breakpoints.up('md')]: {
      height: spacing(5),
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
    },
    [breakpoints.down('sm')]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  subTopic1: {
    [breakpoints.up('md')]: {
      height: spacing(3),
      display: 'flex',
      marginLeft: '3%',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
    },
    [breakpoints.down('sm')]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  state: {
    [breakpoints.up('md')]: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: '20px',
      marginRight: '5%',
      marginBottom: '4%',
    },
    [breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '20px',
      marginTop: spacing(1),
    },
  },
  side: {
    [breakpoints.up('md')]: {
      display: 'flex',
      flexDirection: 'row',
    },
  },
  errorDiv: {
    paddingBottom: '10%',
  },
  searchBarContainer: {
    display: 'flex',
    width: '100%',
    padding: spacing(0, 1, 4, 1),
  },
  searchBar: {
    width: '100%',
    '& div': {
      '& input': {
        padding: spacing(1.5, 1.5, 1.5, 0),
      },
    },
  },
  searchIcon: {
    display: 'flex',
    paddingRight: spacing(1),
  },
  viewVideoActionButton: {
    borderColor: palette.green.main,
    color: palette.green.main,
    fontFamily: 'Open Sans',
    fontWeight: 'bold',
    textTransform: 'none',
    borderWidth: spacing(0.25),
    borderRadius: spacing(0.5),
    minHeight: spacing(5),
    padding: spacing(0.5, 1.75),
    '&:hover': {
      borderColor: palette.green.main,
      backgroundColor: 'rgba(8, 124, 88, 0.06)',
    },
    minWidth: spacing(20),
  },
  viewVideoActionIcon: {
    fontSize: spacing(3),
  },
  uploadActionButton: {
    color: palette.black.main,
    borderColor: palette.black.main,
    fontFamily: 'Open Sans',
    fontWeight: 'bold',
    textTransform: 'none',
    padding: spacing(0.5, 1.75),
    minHeight: spacing(5),
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
    minWidth: spacing(20),
  },
  uploadActionIcon: {
    fontSize: spacing(2.5),
  },
  inlineVideoItem: {
    marginBottom: spacing(3),
    '&:last-child': {
      marginBottom: 0,
    },
  },
  inlineVideoName: {
    fontFamily: 'Open Sans',
    fontWeight: 'bold',
    fontSize: spacing(1.75),
    marginBottom: spacing(0.5),
    wordBreak: 'break-word',
  },
  inlineVideoMeta: {
    display: 'block',
    color: '#666',
    marginBottom: spacing(1),
  },
  inlineVideoWrapper: {
    position: 'relative',
    width: '100%',
    paddingTop: '56.25%', // 16:9 aspect ratio
    backgroundColor: '#000',
    borderRadius: spacing(0.5),
    overflow: 'hidden',
  },
  inlineVideo: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    display: 'block',
  },
}));
